import React from 'react';
import { useMap } from 'react-leaflet';
import './ZoomButtons.css';

/**
 * ZoomButtons Component
 * Provides zoom in/out controls for the Leaflet map.
 * `className` / `buttonClassName` let a module restyle the shared control.
 * `onZoom(zoom)` fires after a button zoom, for modules that sync several maps.
 */
function ZoomButtons({ className = '', buttonClassName = '', onZoom }) {
  const map = useMap();

  // Only listen when the zoom can actually change, otherwise the one-shot
  // listener would fire on some later, unrelated zoom.
  const notifyZoom = (canZoom) => {
    if (onZoom && canZoom) map.once('zoomend', () => onZoom(map.getZoom()));
  };

  const handleZoomIn = () => {
    notifyZoom(map.getZoom() < map.getMaxZoom());
    map.zoomIn();
  };

  const handleZoomOut = () => {
    notifyZoom(map.getZoom() > map.getMinZoom());
    map.zoomOut();
  };

  const buttonClass = buttonClassName || 'zoom-button';

  return (
    <div className={`zoom-buttons ${className}`.trim()}>
      <button
        type="button"
        onClick={handleZoomIn}
        title="Zoom in"
        className={`${buttonClass} zoom-button-in`}
        aria-label="Zoom in"
      >
        +
      </button>
      <button
        type="button"
        onClick={handleZoomOut}
        title="Zoom out"
        className={`${buttonClass} zoom-button-out`}
        aria-label="Zoom out"
      >
        -
      </button>
    </div>
  );
}

export default ZoomButtons;
